import React, { useState } from 'react'
import moment from 'moment'
import { withStyles, createStyles } from '@mui/styles'
import { FormGroup, FormControlLabel, Checkbox } from '@mui/material'
import { muiOptions, MuiProps, defaultColors } from '../../infrastructure/materialUiThemeProvider'
import { t } from '../../infrastructure/i18nextHelper'
import * as api from '../../infrastructure/api'
import { hasFeature } from '../../infrastructure/feature'
import { SnackbarContainer } from '../../infrastructure/snackbars'
import { DatePicker, MonthPicker } from '../common/customComponents'
import { generatePrimoFiles } from '../report/reports/primo'

export type PrimoExportParam = {
    doExport: boolean | null
    exportFinishedHandler: (closeDialog: boolean) => void
    defaultForcastStartDate: string | null
    defaultFromMonth: string | null
}

let _primoExport = ({ classes, doExport, exportFinishedHandler,
    defaultForcastStartDate, defaultFromMonth }: PrimoExportParam & MuiProps) => {
    let dateFormat = 'YYYY-MM-DD'
    let initialFromMonth = defaultFromMonth ?? moment().startOf('month').add(-1).startOf('month').format(dateFormat)
    let initialToMonth = moment(initialFromMonth).add(2, 'M').format(dateFormat)

    let [forecastStart, setForecastStart] = useState<string | null>(defaultForcastStartDate)
    let [fromMonth, setFromMonth] = useState<string | null>(initialFromMonth)
    let [toMonth, setToMonth] = useState<string | null>(initialToMonth)
    let [withSingleFlows, setWithSingleFlows] = useState<boolean>(true)
    let [withAggregatedFlows, setWithAggregatedFlows] = useState<boolean>(true)

    let snackbar = SnackbarContainer.useContainer()

    let generatePrimo = async () => {
        if (!withSingleFlows && !withAggregatedFlows) {
            snackbar.info(t('report.primo.noExportWithoutSelection'))
            exportFinishedHandler(false)
            return
        }
        
        await generatePrimoFiles(fromMonth, toMonth, forecastStart, withSingleFlows, withAggregatedFlows);

        exportFinishedHandler(true)
    }

    if (doExport)
        generatePrimo()

    return (
        <div className={classes.container}>
            <FormGroup>
                <FormControlLabel
                    control={<Checkbox style={{ color: defaultColors.red.main.color }} checked={withSingleFlows}
                        onChange={() => setWithSingleFlows(!withSingleFlows)} />}
                    label={t('report.primo.withSingleFlows')} />
                <FormControlLabel
                    control={<Checkbox style={{ color: defaultColors.red.main.color }} checked={withAggregatedFlows}
                        onChange={() => setWithAggregatedFlows(!withAggregatedFlows)} />}
                    label={t('report.primo.withAggregatedFlows')} />
            </FormGroup>
            {hasFeature('MarketRiskPastForecast') &&
                <DatePicker classesOverride={{ datepicker: classes.datePicker }} date={forecastStart}
                    label={t('report.forecastStart')} setDate={newDate => setForecastStart(newDate)} size='standard' />}
            <MonthPicker classesOverride={{ datepicker: classes.datePicker }} date={fromMonth}
                label={t('report.fromMonth')} setDate={setFromMonth} size='standard' />
            <MonthPicker classesOverride={{ datepicker: classes.datePicker }} date={toMonth}
                label={t('report.toMonth')} setDate={setToMonth} size='standard' />
        </div>
    )
}

let styles = theme => createStyles({
    container: {
        display: 'flex',
        alignItems: 'center'
    },
    datePicker: {
        marginLeft: '1em'
    }
})

export default withStyles(styles, muiOptions)(_primoExport)